export enum BarCloseStateEnum {
    New = 'New',
    Close = 'Close',
}
